import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Avatar,
  Box,
  Icon,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
import { toast } from "react-toastify";
import { getClientByCnpj } from "../services/clientService";
import { useUserStore } from "../store/userStore";
import { EditUserModal } from "./EditUserModal";

const ProfileCard: React.FC = () => {
  const [clientCode, setClientCode] = useState<number>(0);
  const [openEditModal, setOpenEditModal] = useState(false);
  const picture = useUserStore((state) => state.picture);
  const clientName = useUserStore((state) => state.clientName);
  const cnpj = useUserStore((state) => state.cnpj);
  const profile = useUserStore((state) => state.profile);

  const fetchUserData = async () => {
    try {
      const [attributes, session] = await Promise.all([
        fetchUserAttributes(),
        fetchAuthSession(),
      ]);

      useUserStore.getState().setUserData({
        picture: attributes?.picture || "",
        clientName: attributes?.name || "",
        cnpj: attributes?.["custom:cnpj"] || "36977086000154",
        profile: session.tokens?.idToken?.payload?.["cognito:groups"] || [],
        email: attributes?.email || "",
        idToken: session.tokens?.idToken?.toString() ?? "",
      });
    } catch (error) {
      console.error("Erro ao buscar dados do usuário:", error);
    }
  };

  const fetchClientInfo = async (cnpj: string) => {
    try {
      const data = await getClientByCnpj(cnpj);
      setClientCode(data?.CODIGO ?? 0);
    } catch (err) {
      toast.error("Erro ao buscar cliente");
      console.error("Erro ao buscar cliente:", err);
    }
  };

  useEffect(() => {
    // if (!openEditModal) {
    fetchUserData();
    // }
  }, [openEditModal]);

  useEffect(() => {
    if (cnpj && profile?.includes("cliente")) {
      fetchClientInfo(cnpj);
    }
  }, [cnpj, profile]);

  useEffect(() => {
    if (clientCode) {
      useUserStore.getState().setClientId(String(clientCode));
    }
  }, [clientCode]);

  const [firstName = "", lastName = ""] = clientName?.trim()?.split(" ") ?? [];

  return (
    <>
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: 2,
          width: "100%",
          boxShadow: 3,
          position: "relative",
          backgroundColor: "#0A0C33",
          borderRadius: "17px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginRight: 2,
            marginLeft: "36px",
          }}
        >
          <Avatar
            src={picture || undefined}
            alt="Avatar"
            sx={{
              width: 80,
              height: 80,
              border: "2px solid #A5EB17",
              backgroundColor: picture ? "transparent" : "#326AFD",
              color: picture ? "inherit" : "#FFFFFF",
              fontWeight: picture ? "normal" : "bold",
              fontSize: "1.8rem",
            }}
            imgProps={{
              style: {
                objectFit: "cover",
                objectPosition: "center top",
              },
            }}
          >
            {!picture && `${firstName[0] || ""}${lastName[0] || ""}`}
          </Avatar>
        </Box>
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "green", marginBottom: 1 }}
          >
            {firstName} <span style={{ fontWeight: "normal" }}>{lastName}</span>
          </Typography>
          <Typography variant="body2" style={{ color: "#FFFFFF" }}>
            {profile
              ?.map((p: any) => p[0].toUpperCase() + p.slice(1).toLowerCase())
              .join(", ")}{" "}
            {profile?.includes("cliente") && `#${clientCode}`}
          </Typography>
        </CardContent>
        <div
          onClick={() => setOpenEditModal(true)}
          style={{ cursor: "pointer" }}
        >
          <Icon
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              width: "24px",
              height: "24px",
              background: "transparent",
              "& svg": {
                height: "auto",
                margin: 0,
              },
            }}
          >
            <MoreVertIcon sx={{ color: "white" }} />
          </Icon>
        </div>
      </Card>
      <EditUserModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
      />
    </>
  );
};

export default ProfileCard;
